import SpeakerView from './SpeakerView';

export default SpeakerView;
